import React, { useEffect } from "react";
import "./Services.css";
import scImg from "../assets/services_supply_chain_inspection.webp";
import tpiImg from "../assets/services_Project_Inspection.jpg"; // Using for Third & Second Party Inspection
import expediteImg from "../assets/services_Expediting_Services.webp";
import designImg from "../assets/services_Engineering_Design_Inspection.jpg";
import projectImg from "../assets/services_Project_Inspection.jpg";
import sourcingImg from "../assets/services_International_Sourcing_Inspection.jpg";
import shutdownImg from "../assets/services_Shutdown_Inspection.jpg";
import witnessImg from "../assets/services_witness_performance.jpg";
import psiImg from "../assets/services_Pre_Shipment_Inspection.jpeg";
import processQualImg from "../assets/services_process_qualification.jpg";
import personnelImg from "../assets/services_Personnel_Qualification.avif";
import certImg from "../assets/services_Certification_of_Materials_and_Welding_Consumables.jpg";
import pipingImg from "../assets/services_Process Piping Inspection.jpg";
import tankImg from "../assets/services_API_Tank_Inspection.jpg";


const Services = () => {
  useEffect(() => {
    document.title = "Services | Qnexa Services — Engineering & Inspection Specialists";
  }, []);

  const names = [
    "Supply chain inspection",
    "Third & Second Party Inspection",
    "Expediting Services",
    "Engineering Design Inspection",
    "Project Inspection",
    "International Sourcing Inspection",
    "Shutdown Inspection",
    "Witnessing Performance Test",
    "Pre-Shipment Inspection",
    "Process Qualification",
    "Personnel Qualification",
    "Certification of Materials and Welding Consumables",
    "Process Piping Inspection",
    "API Tank Inspection",
  ];

  // Provide a small set of images and reuse them for missing items

  const cards = [
  { id: 1, title: "Supply Chain Inspection", img: scImg },
  { id: 2, title: "Third & Second Party Inspection", img: tpiImg },
  { id: 3, title: "Expediting Services", img: expediteImg },
  { id: 4, title: "Engineering Design Inspection", img: designImg },
  { id: 5, title: "Project Inspection", img: projectImg },
  { id: 6, title: "International Sourcing Inspection", img: sourcingImg },
  { id: 7, title: "Shutdown Inspection", img: shutdownImg },
  { id: 8, title: "Witnessing Performance Test", img: witnessImg },
  { id: 9, title: "Pre-Shipment Inspection", img: psiImg },
  { id: 10, title: "Process Qualification", img: processQualImg },
  { id: 11, title: "Personnel Qualification", img: personnelImg },
  { id: 12, title: "Certification of Materials and Welding Consumables", img: certImg },
  { id: 13, title: "Process Piping Inspection", img: pipingImg },
  { id: 14, title: "API Tank Inspection", img: tankImg },
];


  return (
    <div className="services-page">
      <div className="services-banner">
        <h1>Services</h1>
      </div>

      <div className="services-body">
        <div className="services-grid">
          {cards.map((c) => (
            <article key={c.id} className="service-card" aria-label={c.title}>
              <div
                className="service-image"
                style={{ backgroundImage: `url(${c.img})` }}
                role="img"
                aria-hidden="true"
              />
              <div className="service-content">
                <div className="service-title">{c.title}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
